import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./HomePage/Home";
import AOS from "aos";
import "aos/dist/aos.css";
import ProjectDetails from "./Components/ProjectDetails";
import ToolsDetaile from "./Components/ToolsDetaile";
import FruitDetails from "./Components/FruitDetails";
import PhotoDetails from "./Components/PhotoDetails";
import AboutPage from "./HomePage/AboutPage";
import Blogs from "./HomePage/Blogs";
import Contact from "./HomePage/Contact";

function App() {
  AOS.init();

  return (
    <div className="text-base-100">
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/home" element={<Home />}></Route>
        <Route path="/about" element={<AboutPage />}></Route>
        <Route path="/blogs" element={<Blogs />}></Route>
        <Route path="/contact" element={<Contact />}></Route>
        <Route path="/ProjectDetails" element={<ProjectDetails />}>
          <Route path="Mr.tools" element={<ToolsDetaile />}></Route>
          <Route path="fruitShop" element={<FruitDetails />}></Route>
          <Route path="khPhotography" element={<PhotoDetails />}></Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
